import pluralize from 'pluralize';
import type { FC, ReactNode } from 'react';

import CollapsibleSection from '@zen/Components/CollapsibleSection';

import AuditLogItem from '../AuditLogItem';
import type { AuditLogNode } from '../types';

interface AuditLogGroupProps {
  auditLogs: AuditLogNode[];
  dateLabel: string;
  isExpandedInitially: boolean;
}

const AuditLogGroup: FC<AuditLogGroupProps> = (props) => {
  const { dateLabel, auditLogs, isExpandedInitially } = props;

  const logItems: ReactNode[] = auditLogs.map((auditLog: AuditLogNode) => <AuditLogItem key={auditLog.id} auditLog={auditLog} />);

  const entryCountText = pluralize('entry', auditLogs.length, true);

  return (
    <div className="bg-white border border-grey-lighter rounded-md p-4 shadow-xs mb-4">
      <h3 className="text-xs font-bold uppercase tracking-wider text-grey-base mb-3">
        {dateLabel} ({auditLogs.length})
      </h3>

      <CollapsibleSection
        renderItems={logItems}
        initialDisplayedItems={0}
        isExpandedInitially={isExpandedInitially}
        expandLabel={`Show all ${entryCountText}`}
        collapseLabel="Hide entries"
      />
    </div>
  );
};

export default AuditLogGroup;
